import { atom } from "recoil";

export const showKeyboardState = atom({
  key: "showKeyboardState",
  default: {
    showKeyboard: false,
    input: "", 
  },
});
